var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"additionalTips",staticClass:"images-mosaic list-container",class:{ 
    'hide-num': _vm.isShowNum === 'false', 
    'rtlEnable': !_vm.isRTLEnable === false,
    'no-content-mode': !_vm.isContentAvailableBoolean
  }},[(!_vm.isRTLEnable)?_c('VueSlickCarousel',_vm._b({key:'ltr-' + _vm.refreshKey},'VueSlickCarousel',_vm.computedSettings,false),[_vm._t("default")],2):_c('VueSlickCarouselRtl',_vm._b({key:'rtl-' + _vm.refreshKey,attrs:{"rtl":true}},'VueSlickCarouselRtl',_vm.computedSettings,false),[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }